export const odluka_udaljenje = {
    templateId: 29.1,
    category: 3,
    templateTitle: 'Odluka o privremenom udaljenju s posla',
    templateDescription: `<p>U slučaju da radnik osporava odluku o izvanrednom otkazu ugovoru o radu i traži povratak na posao do završetka spora, poslodavac ima mogućnost radnika privremeno udaljiti s posla. </p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Zakon o radu propisuje mogućnost da poslodavac privremeno udalji radnika s posla u slučaju kada poslodavac izvanredno otkazuje ugovor o radu, a radnik osporava dopuštenost otkaza i traži od poslodavca da ga zadrži na radu do okončanja sudskog spora.    </p>
    <p>Poslodavac može privremeno udaljiti radnika s posla samo u slučaju ako izvanredno otkazuje ugovor o radu i ako je riječ o osobito teškoj povredi obveze iz radnog odnosa, a nakon što radnik u sudskom sporu osporava dopuštenost otkaza i traži od poslodavca da ga zadrži na radu do okončanja sudskog spora. </p>
    <p>Poslodavac <strong>neće</strong> imati mogućnost privremeno udaljiti radnika pri pokretanju ili prije pokretanja postupka redovitog otkaza uvjetovanog skrivljenim ponašanjem radnika ("Kad je poslodavac donio odluku o redovitom, a ne izvanrednom otkazu ugovora o radu, nisu bile ispunjene pretpostavke predviđene odredbom čl. 152. t. 10. ZR/04 za donošenje odluke o privremenom udaljenju tužitelja kao radnika“, Vrhovni sud RH, Revr-525/06 od 29. studenog 2006.).</p>
    <p>Važno je naglasiti da poslodavac za vrijeme udaljenja radnika s posla, do okončanja sudskog postupka ima obvezu isplaćivati mjesečnu naknadu plaće u visini polovice prosječne plaće isplaćene tom radniku u prethodna tri mjeseca.  </p>
    <h5>PRAVNA OSNOVA</h5>
    <p> Zakon o radu.</p>
  `,
    sides: [
        {
            prefix: 'Na temelju Zakona o radu,',
            signature: 'Za Poslodavca:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
            suffix: ' (u daljnjem tekstu: Poslodavac),',
        }
    ],

    headline: 'donosi sljedeću',
    title: 'ODLUKU O PRIVREMENOM UDALJENJU S POSLA',
    noArticleNumbers: true,
    
    articles: [
      {
          mandatory: true,
          statements: [
              {
                  title: '',
                  type: 'input',
                  mandatory: true,
                  editable: true,
                  parts: [
                      {type: 'text', content: 'Radniku'},
                      { type: 'input', value: '', required: true, placeholder: "Ime i prezime" },
                      { type: "text", content: "," },
                      { type: 'text', content: 'iz',},
                      { type: 'input', value: '', required: true, placeholder: "Mjesto"   },
                      { type: 'text', content: ',' },
                      { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj" },
                      { type: "text", content: "," },
                      { type: 'text', content: 'OIB:' },
                      {type: 'input', value: '', required: true},
                      {type: 'text', content: '(u daljnjem tekstu: Radnik), je dana'},
                      {type: 'input', value: '', required: true},
                      {type: 'text', content: ' uručena Odluka o izvanrednom otkazu ugovora o radu jer je učinio osobito tešku povredu iz radnog odnosa zbog čega nastavak radnog odnosa između Poslodavca i Radnika nije moguć.'},
                  ],
                  value: '',
              },
          ],
      },
        {
            mandatory: true,
            statements: [
                {
                    title: '',
                    type: 'text',
                    mandatory: true,
                    editable: false,
                    content: 'Radnik je u zakonskom roku tužbom zatražio osporavanje dopuštenosti otkaza i tražio od Poslodavca da ga zadrži na radu do okončanja sudskog spora, najkasnije u roku od osam dana od dana dostave obavijesti i dokaza o podnošenju tužbe.',
                    value: '',
                }],
        },
        {
          mandatory: true,
          statements: [
              {
                  title: '',
                  type: 'text',
                  mandatory: true,
                  editable: false,
                  content: 'Poslodavac ovom Odlukom, a sukladno Zakonu o radu, udaljuje radnika s posla do okončanja sudskog spora o dopuštenosti otkaza, uz obvezu isplate mjesečne naknade plaće u visini polovice prosječne plaće isplaćene tom radniku u prethodna tri mjeseca.',
                  value: '',
              }],
      },
      {
        title: '------------------------------------------------------Obrazloženje------------------------------------------------------',
        mandatory: true,
        dummy: true,
        statements: [
          {
            type: "input",
            mandatory: true,
            editable: false,
            parts: [ 
              {type: 'text', content: 'Poslodavac je Radniku dana'},
              {type: 'input', value: '', required: true},
              {type: 'text', content: 'godine uručio Odluku o izvanrednom otkazu ugovora o radu, a povodom koje je Radnik tužbom zatražio osporavanje dopuštenosti otkaza i tražio od Poslodavca da ga zadrži na radu do okončanja sudskog spora, u roku od osam dana od dana dostave obavijesti i dokaza o podnošenju tužbe.                      '},
      ],
      },
    ]
  },
      {
        title: "",
        mandatory: true,
        dummy: true,
        statements: [
          {
            type: "text",
            mandatory: true,
            editable: true,
            content: "Poslodavac je koristeći svoje zakonsko pravo, odlučio kao u izreci."
          }]
      },
      {
        title: "",
        mandatory: true,
        dummy: true,
        statements: [
          {
            type: "text",
            mandatory: true,
            editable: true,
            content: "Slijedom iznesenog, donesena je ova Odluka. "
          }]
      },
      {
        title: "NAPUTAK O ZAŠTITI PRAVA",
        mandatory: true,
        dummy: true,
        statements: [
          {
            type: "text",
            mandatory: true,
            editable: false,
            content: "Protiv ove Odluke Radnik može Poslodavcu podnijeti zahtjev radi zaštite svojih prava, u roku od 15 dana od dana dostave ove Odluke."
          }]
      },
      {
          mandatory: true,
          static: true,
          type: 2, // date and place
          statements: [
            {
              type: "input",
              mandatory: true,
              parts: [
                {
                  type: "text",
                  content: "U"
                },
                {
                  type: "input",
                  value: "",
                  placeholder: "Upišite mjesto.",
                  required: true,
                },
                {
                  type: "text",
                  content: ", dana"
                },
                {
                  type: "date",
                  value: new Date(),
                  required: true
                },
                {
                  type: "text",
                  content: "godine."
                }
              ]
            },
          ]
        },
      {
          mandatory: true,
          static: true,
          type: 3,  // signatures
          statements: [],
        },
        {
          static: true,
          mandatory: false,
          type: 4, 
          statements: [
            {
              type: 'text',
              mandatory: true,
              editable: true,
              content: 'Dostaviti:\r\n1) Radniku\r\n2) Kadrovska služba',
              help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
            }
          ]
        },
        {
          static: true,
          mandatory: true,
          type: 4, 
          statements: [
            {
              type: 'text',
              mandatory: true,
              editable: true,
              help: 'Ako postupak dostave nije uređen kol. ug., sporazumom između radničkog vijeća i poslodavca ili pravilnikom o radu, primjenjuju se odredbe o dostavi određene parničnim postupkom. U tom slučaju, otkaz se može dostaviti prep. pošt. pošiljkom s povr. ili osobno, na radnom mjestu, no ukoliko radnik odbija primiti odluku, navedeno odbijanje može se pisano konstatirati uz potpis dva svjedoka. Otkaz se može dostaviti i putem j. bilježnika.',
              content: 'Potvrđujem primitak Odluke dana _______________ godine.\r\n\r\nPotpis Radnika: ____________________\r\n\r\n',
            },
          ]
        },
      ],
    };
    


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/29.1_odluka_udaljenje.ts